import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigurationService } from '../../../services/configuration.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent {
  showPlaylist: boolean = false;

  @Input() set showPlaylistIframe(i: boolean) {
    i != undefined && i != null && (this.showPlaylist = i);
  }


  constructor(public configurations: ConfigurationService, 
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef) {
  }


  ngOnInit() {
    //this.showPlaylist = this.authService.isDelegationMode;
    //this.cdr.markForCheck();
  }
}

